import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Img } from "../Images";
// eslint-disable-next-line import/no-cycle
import { WeddingModalForm } from "../../components/WeddingForm";
import { Icon } from "../../components/Icons";
import * as styles from "./MagazinePreviewBlock.module.scss";

const MagazinePreviewBlock = ({
	customClasses,
	blockImage,
	sourceSet,
	blockText,
	magazineCoverImageUrl,
	magazineLink,
	magazineModal,
}) => (
	<div className={cx(styles.magazinePreviewBlockContainer)}>
		<div className={cx(styles.magazineCard, customClasses.card)}>
			{(blockImage || typeof blockImage === "object") && (
				<div className={cx(styles.cardImageContainer, customClasses.cardImageContainer)}>
					<Img
						src={!sourceSet && (blockImage || blockImage?.fluid?.src)}
						source={sourceSet}
						alt={blockText && blockText}
					/>
				</div>
			)}

			<div className={cx(styles.cardDescription, customClasses.description)}>
				{blockText && <div className={cx(styles.cardText, customClasses.text)}>{blockText}</div>}

				{!magazineModal && magazineCoverImageUrl && (
					<div
						className={cx(
							styles.magazineImageContainer,
							customClasses.magazineImageContainer,
							styles.orig
						)}>
						<div className={cx(styles.magazineImage, customClasses.magazineImage)}>
							<img src={magazineCoverImageUrl} alt={blockText && blockText} />
							<span className={cx(styles.previewLink, customClasses.previewLink)}>
								<Icon name="gallery" />
							</span>
						</div>
						{magazineLink && (
							<a
								href={magazineLink.url && magazineLink.url}
								target={magazineLink.target}
								className={cx(styles.magazineLink)}>
								<span className="sr-only">{blockText && blockText}</span>
							</a>
						)}
					</div>
				)}
				{magazineModal && magazineCoverImageUrl && (
					<WeddingModalForm
						config={magazineModal}
						image={magazineCoverImageUrl}
						alt={blockText && blockText}
					/>
				)}
			</div>
		</div>
	</div>
);

MagazinePreviewBlock.propTypes = {
	customClasses: PropTypes.shape({
		card: PropTypes.string,
		cardImageContainer: PropTypes.string,
		magazineImageContainer: PropTypes.string,
		previewLink: PropTypes.string,
		description: PropTypes.string,
		text: PropTypes.string,
		magazineImage: PropTypes.string,
	}),
	blockImage: PropTypes.oneOf([PropTypes.string, PropTypes.object]),
	sourceSet: PropTypes.object,
	blockText: PropTypes.string,
	magazineCoverImageUrl: PropTypes.string,
	magazineLink: PropTypes.object,
	magazineModal: PropTypes.object,
};

MagazinePreviewBlock.defaultProps = {
	customClasses: null,
	blockImage: null,
	sourceSet: null,
	blockText: null,
	magazineCoverImageUrl: null,
	magazineLink: null,
	magazineModal: null,
};

export { MagazinePreviewBlock };
